
const util = require('util');

const bytes = require('bytes');

const vb = require('../definition');

const {
	unwrap,
} = require('../util');

vb.fileMaxSize = (maxSize, textNotice = 'не более') => {
	return {
		validator: f => {
			const maxSizeValue = bytes.parse(unwrap(maxSize));
			const fileSize = f && f.Size();
			return !fileSize
				|| (fileSize <= maxSizeValue);
		},
		message: () => {
			const maxSizeRepr = bytes(bytes.parse(unwrap(maxSize)));
			return util.format(`${textNotice} %s`, maxSizeRepr);
		},
	};
};
